// extracted by mini-css-extract-plugin
module.exports = {"text":"text__pN0zc"};